// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
// `.env.ts` is generated by the `npm run env` command
// import env from './.env';

const production = 'true';
const serverUrl = 'https://ruckit-platform-dev.herokuapp.com/api/';
const imageServerUrl = 'http://ruckit-platform-dev.s3-website-us-east-1.amazonaws.com';
const resizeImageServerUrl = 'https://d2o05km0cx02l1.cloudfront.net';
const ticketImageServerUrl = 'https://s3.amazonaws.com/ruckit-platform-dev/';
const errorTrackingEnv = 'dev';
const googleMapsKey = 'AIzaSyBnyQsblAiJeVVAHKQyo76Nx8PVp-N2mLU';
const applicationVersion = '2021.2.0-7ad7759-develop';
const scaleitUrl = 'https://api.scaleitusa.com/api/ruckit/v1/';
const ptpRuckitKey = 'ae59267f5b435adfb6f00dbcee33b5341eef94c9';
const ptpApiKey = '958616b01e9bb274ff6278e02b19d9f3';
const ptpUrl = 'https://pitticketpro-staging.herokuapp.com/partner_api/ticket_manager';

export const environment = {
  production: production.toString() === 'false',
  serverUrl,
  imageServerUrl,
  resizeImageServerUrl,
  ticketImageServerUrl,
  scaleitUrl,
  ptpRuckitKey,
  ptpApiKey,
  ptpUrl,
  errorTrackingEnv,
  applicationVersion,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
    'fr-FR'
  ],
  googleMapsKey
};
